import { useEffect } from 'react'
import { useStore } from '../../store/basic-store'
import { getWatchLists } from '../../service/dlist.action'
import { Layout, Table } from 'antd'
import { Content, Header } from 'antd/es/layout/layout'
import { BackHome } from '../../components/back-home'
import { WatchList } from '../../types'

export function WatchListTable({ stocks }: { stocks: WatchList[] }) {
  const columns = [
    {
      title: 'Ticker',
      dataIndex: 'T',
      key: 'T',
    },
    {
      title: 'Buy Cycle',
      dataIndex: 'buyCycle',
      key: 'buyCycle',
    },
    {
      title: 'Added',
      dataIndex: 'added',
      key: 'added',
    },
    {
      title: 'Health Score',
      dataIndex: 'healthScore',
      key: 'healthScore',
    },
    {
      title: 'Close',
      dataIndex: 'close',
      key: 'close',
    },
  ]
  return <Table dataSource={stocks} columns={columns} />
}
/*
{watchList.map((stock) => (
                  <div key={stock.T}>
                    {stock.T} - {stock.buyCycle} - {stock.added} - {stock.healthScore} - {stock.close}
                  </div>
                ))}
*/
export function WatchListPage() {
  const watchLists = useStore<Record<string, WatchList[]>>('dlist/watch-lists')

  console.log('watchLists', watchLists)

  useEffect(() => {
    if (!watchLists) {
      getWatchLists()
    }
  }, [watchLists])

  return (
    <Layout>
      <Header>
        <BackHome />
        <h1>Watch Lists</h1>
      </Header>
      <Content>
        {Object.keys(watchLists || {}).map((key) => {
          if (!watchLists) return <></>
          const watchList = watchLists[key]
          // watchList.map
          return (
            <div key={key}>
              <h2>{key}</h2>
              {key === 'favorites' ? <div>This is the core of what I am currently holding. I am about 40% YMAX, and 40% ULTY.</div> : null}
              <div>
                <WatchListTable stocks={watchList} />
              </div>
            </div>
          )
        })}
      </Content>
    </Layout>
  )
}
